﻿/**
* DevExpress Analytics (core\internal\_ajaxSetup.js)
* Version:  21.2.7
* Build date: Apr 13, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var _utils_1 = require("../../serializer/_utils");
var AjaxSetup = (function () {
    function AjaxSetup() {
        this.ajaxSettings = {};
    }
    AjaxSetup.prototype.sendRequest = function (settings) {
        return $.ajax(_utils_1.extend({}, this.ajaxSettings, settings));
    };
    return AjaxSetup;
}());
exports.AjaxSetup = AjaxSetup;
